module.exports = __webpack_public_path__ + "img/740.303f0971.jpg";